<template>
  <div class="course-box slide-in-on-scroll" v-observe-visibility="observeVisibilityOptions" :style="{ 'border-right': '1rem solid ' + accent }">
    <h3>{{ headline }}</h3>
    <p class="course-details">{{ $t("coaching.duration") }}: {{ duration }} | {{ $t("coaching.format") }}: {{ format }} | {{ $t("coaching.trainer") }}: {{ trainer }}</p>
    <p>{{ text }}</p>
  </div>
</template>

<script>
import visibilityChange from "@/mixins/visibility-change";

export default {
  mixins: [visibilityChange],
  props: {
    headline: {
      type: String
    },
    text: {
      type: String
    },
    accent: {
      type: String,
      default: "transparent"
    },
    duration: {
      type: String
    },
    format: {
      type: String
    },
    trainer: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.course-box {
  background: #eee;
  padding: 2rem;
  font-size: 1.25rem;
  font-weight: 300;
  margin-bottom: 2rem;
}

.course-details {
  font-size: 1rem;
}
</style>
